import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'

export class GetDealerRemoteListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'dealer/getDealerRemoteList',
      requesterInfo,
    })
  }

  public async getDealerRemoteList(): Promise<[]> {
    return await this.getAsync<[]>()
  }
}
